// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Entity.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumDataType } from '../../../../../com/MetaPattern/Core/Infrastructure/Common/EnumDataType';
import { MDParameter } from './MDParameter';
import { EnumHTTPParameterSource } from '../../../../../com/MetaPattern/MDA/MD/EntityModel/EnumHTTPParameterSource';
import { BEExternalService } from './BEExternalService';
import { PGContext } from '../../../../../../libs/com/MetaPattern/MDA/MD/PGContext';
/**
 * 外部服务参数 实体类
 * 外部服务参数
 */
export class ESParameter extends MDParameter {
  /** 是否可空 : 是否可空 */
  private _isNullable: boolean;

  /** 设置：是否可空 */
  public get isNullable() {
    return this._isNullable;
  }

  /** 获取：是否可空 */
  public set isNullable(value: boolean) {
    this._isNullable = value;
  }

  /** 参数来源 : 暴露为服务时，Http协议的参数来源 */
  private _httpParameterSource: EnumHTTPParameterSource;

  /** 设置：参数来源 */
  public get httpParameterSource() {
    return this._httpParameterSource;
  }

  /** 获取：参数来源 */
  public set httpParameterSource(value: EnumHTTPParameterSource) {
    this._httpParameterSource = value;
  }

  /** 外部服务 的ID */
  private _externalService_ID: string;

  /** 获取：外部服务 的ID */
  public get externalService_ID() {
    return this._externalService_ID;
  }

  /** 设置：外部服务 的ID */
  public set externalService_ID(value: string) {
    this._externalService_ID = value;
  }

  /** 外部服务  */
  private _externalService: BEExternalService;

  /** 获取：外部服务  */
  public get externalService() {
    return this._externalService;
  }

  /** 设置：外部服务  */
  public set externalService(value: BEExternalService) {
    this._externalService = value;
    if (value !== null) {
      this.externalService_ID = value.id;
    } else {
      this.externalService_ID = '';
    }
  }

  constructor() {
    super();
    this._isNullable = false;
    this._httpParameterSource = EnumHTTPParameterSource.Query;
    this._externalService_ID = '';
    this._externalService = null;
  }

  /**
   * 将对象进行所有属性值的复制
   * @param element 要复制的对象
   * @param hasReference 是否复制引用实体
   */
  public copyFrom(element: ESParameter, hasReference: boolean): void {
    if (element != null) {
      super.copyFrom(element, hasReference);
      this.isNullable = element.isNullable;
      this.httpParameterSource = element.httpParameterSource;
      this.externalService_ID = element.externalService_ID;
      if (hasReference && element.externalService !== null) {
        this.externalService = element.externalService;
      }
    }
  }

  protected Deserialize(json: any): void {
    super.Deserialize(json);
    // Add self attribute
    this.isNullable = json.IsNullable;
    this.httpParameterSource = json.HttpParameterSource as EnumHTTPParameterSource;
    this.externalService_ID = json.ExternalService_ID;
    // if (json.ExternalService !== null) {
    //   this.externalService = BEExternalService.Create(json.ExternalService);
    // }
  }

  protected Serialize(json: any): void {
    super.Serialize(json);
    json.IsNullable = this.isNullable;
    json.HttpParameterSource = this.httpParameterSource;
    json.ExternalService_ID = this.externalService_ID;
  }

  /** 获取属性框上下文（替代元元数据） */
  GetPGContext (): PGContext {
    const context = new PGContext(this.designId, this.displayName);
    super.buildPGContext(context);
    context.addRow('校验属性', 'isNullable', '是否可空', EnumDataType.Bool, this.isNullable, true, '是否可空', '', '');
    context.addRow('服务', 'httpParameterSource', '参数来源', EnumDataType.Reference, this.httpParameterSource, true, '暴露为服务时，Http协议的参数来源', 'EnumHTTPParameterSource', 'PGRowEnumValue');
    return context;
  }

  static Create(json: any): ESParameter {
    const eSParameter = new ESParameter();
    eSParameter.Deserialize(json);
    eSParameter.json = json;
    return eSParameter;
  }
}
